import { Button, Col, Row } from 'antd';
import styled from 'styled-components';
import BaseUserList from 'features/edit-profile/ShareTrade/UserList';
import BaseAlert from 'global/Alert';
import BaseSearchInput from 'global/Input/SearchInput';
import BaseModal from 'global/Modal/BaseModal';
import {
  HeaderRow as BaseModalHeaderRow,
  Title,
} from 'global/Modal/BaseModal/styled';
import BaseErrorState from 'features/edit-profile/ShareTrade/ErrorState';

export const Modal = styled(BaseModal)`
  & .ant-modal-body {
    padding: 18px 0 20px;
  }

  & ${Title} {
    font-size: 16px;
    line-height: 22px;
  }

  & ${BaseModalHeaderRow} {
    margin-bottom: 18px;
  }
`;

export const HeaderRow = styled(Row)`
  padding: 0 20px;
`;

export const Alert = styled(BaseAlert)`
  padding: 12px 16px;
  text-align: left;

  font-size: 12px;
  font-weight: 400;
  line-height: 16px;

  margin-bottom: 16px;
`;

export const SearchInput = styled(BaseSearchInput)`
  line-height: 19px;
  height: 35px;
`;

export const ListTitle = styled.p`
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;

  color: #969696;

  padding: 16px 0 0;
  margin: 0 0 20px;
`;

export const UserList = styled(BaseUserList)`
  & > .ant-row {
    padding: 0 20px;
  }
  height: 356px;
`;

export const FooterCol = styled(Col)`
  border-top: 1px solid #ededed;
  padding: 12px 20px 0;
`;

export const AgreementRow = styled(Row)`
  margin-bottom: 12px;
  height: 24px;
`;

export const AgreementText = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  color: #333333;

  margin: 0;
`;

export const SubmitButton = styled(Button)`
  height: 44px;
  border-radius: 4px;
  padding: 12px 20px;

  font-size: 14px;
  font-weight: 700;
  line-height: 19px;

  &.ant-btn-primary[disabled] {
    background: #8cd9bc !important;
    color: #ffffff !important;

    &:hover > p {
      color: #ffffff;
    }
  }
`;

export const ErrorState = styled(BaseErrorState)`
  height: 226px;

  & p {
    margin-bottom: 4px;
  }
`;
